import React from "react";
import { Alert, AlertTitle, Typography } from "@mui/material";
import SecurityOutlinedIcon from "@mui/icons-material/SecurityOutlined";

const RecaptchaMessage = ({ isSuccess, score, message }) => {
  const { title, alertColor, severity } = getRecaptchaProps(isSuccess, score);

  return (
    <Alert
      severity={severity}
      variant="outlined"
      sx={{
        backgroundColor: alertColor,
        borderRadius: 2,
        alignItems: "center",
        display: "flex",
      }}
      icon={
        <img
          src="https://www.gstatic.com/recaptcha/api2/logo_48.png" // Google reCAPTCHA logo
          alt="reCAPTCHA"
          style={{ width: "24px", height: "24px" }}
          onError={(e) => {
            e.target.onerror = null; // Prevent infinite loop
            e.target.style.display = "none"; // Hide the broken image
          }}
        /> || <SecurityOutlinedIcon fontSize="small" /> // Fallback icon
      }
    >
      <AlertTitle sx={{ fontWeight: "600", fontSize: "16px" }}>
        Recaptcha Verification
      </AlertTitle>
      <Typography sx={{ fontWeight: "500", fontSize: "14px" }} color="text.secondary">
        {message}
      </Typography>
    </Alert>
  );
};

function getRecaptchaProps(isSuccess, score) {
  if (isSuccess === undefined) {
    return {
      title: "",
      alertColor: "rgba(185, 180, 181, 0.17)", // Neutral gray for undefined
      message: "Verification is pending.",
      severity: "info",
    };
  } else if (isSuccess) {
    return {
      title: "completed",
      alertColor: "rgba(237, 247, 237, 0.5)", // Light green for success
      message: "Verification completed successfully.",
      severity: "success",
    };
  } else {
    return {
      title: "failed",
      alertColor: "rgba(255, 235, 238, 0.3)", // Light red for failure
      message: `Verification failed. Please try again. Score: ${score}`,
      severity: "error",
    };
  }
}

export default RecaptchaMessage;